import { Action } from '@ngrx/store';
import { PagedGridState, gridInstanceReducer } from './grid-instance.reducer';
import { PagedActionsTypesSet, PagedGridActions } from '../paged-grid.actions';

export interface PagedGridInstancesState {
  [key: string]: PagedGridState;
}

export function instancesHandlerReducer(state: PagedGridInstancesState = {}, action: Action): PagedGridInstancesState {
  if (PagedActionsTypesSet.has(action.type)) {
    const instanceId = (action as any).instanceId;

    if (action.type === PagedGridActions.Dispose.type) {
      delete state[instanceId];
    } else if (action.type === PagedGridActions.Init.type) {
      state[instanceId] = gridInstanceReducer(undefined, action);
    } else if (instanceId in state) {
      state[instanceId] = gridInstanceReducer(state[instanceId], action);
    }

    return { ...state };
  }

  return state;
}
